import { Box } from '@chakra-ui/react';

import { ArrowDir } from '../utils';
import { ARROW_HEAD_WIDTHS, BG, TAIL_WIDTH } from './constants';

const Arrowhead = ({
  side,
  isLast,
  isCurrent,
  bgColor = BG,
}: {
  side: ArrowDir;
  isLast: boolean;
  isCurrent: boolean;
  bgColor?: string;
}) => (
  <Box
    display={{ base: isLast ? 'none' : 'block', md: isCurrent && !isLast ? 'none' : 'block' }}
    position="absolute"
    w={ARROW_HEAD_WIDTHS}
    h={isLast && isCurrent ? '100%' : { base: '50px', md: '125%' }}
    top={{ base: `calc(100% - ${ARROW_HEAD_WIDTHS.base} + 12px)`, md: '50%' }}
    transform={{
      base: 'rotate(270deg)',
      md: `translateY(-50%)${side === 'right' ? ' rotate(180deg)' : ''}`,
    }}
    bg="white"
    clipPath="polygon(0 50%, 100% 0, 100% 100%)"
    zIndex={10}
    {...{
      [side]: {
        base: `calc(${ARROW_HEAD_WIDTHS.base} - 10px)`,
        md: `calc(${TAIL_WIDTH[side]} - ${ARROW_HEAD_WIDTHS.md} + 1px)`,
        lg: `calc(${TAIL_WIDTH[side]} - ${ARROW_HEAD_WIDTHS.lg} + 1px)`,
      },
    }}
    _after={{
      content: '""',
      position: 'absolute',
      w: 'calc(100% - 3px)',
      h: '100%',
      bg: bgColor,
      clipPath: 'polygon(0 50%, 100% 0, 100% 100%)',
      top: 0,
      left: '3px',
    }}
  />
);

export default Arrowhead;
